export default __webpack_public_path__ + "3ebd4475ad60f2324e85824af2632f7e.svg";